<div *ngIf="companyInfo?.company" class="grid grid-cols-12 gap-4">
  <!-- COMPANY -->
  <div class="col-span-12 md:col-span-6 xl:col-span-3">
    <div class="min-h-[125px] rounded-2xl border border-gray-300 bg-white p-5">
      <div class="flex flex-col items-center justify-center text-center">
        <div class="mb-3 flex items-center justify-center gap-1">
          <p class="text-xs font-semibold uppercase tracking-[0.16em] text-gray-500">
            Company
          </p>

          <mat-icon
            class="!text-[15px] !text-emerald-500"
            matTooltip="Location: {{ companyInfo?.company?.address || 'Not available' }}"
          >
            info_outline
          </mat-icon>
        </div>

        <p class="max-w-full truncate text-xl font-bold tracking-tight text-gray-900">
          {{ companyInfo?.company?.Name || '---' }}
        </p>
      </div>
    </div>
  </div>

  <!-- ACTIVE FROM -->
  <div class="col-span-12 md:col-span-6 xl:col-span-3">
    <div class="min-h-[125px] rounded-2xl border border-gray-300 bg-white p-5">
      <div class="flex flex-col items-center justify-center text-center">
        <div class="mb-3 flex items-center justify-center gap-1">
          <p class="text-xs font-semibold uppercase tracking-[0.16em] text-gray-500">
            Active From
          </p>

          <mat-icon
            class="!text-[15px] !text-emerald-500"
            matTooltip="Last active at:"
          >
            info_outline
          </mat-icon>
        </div>

        <p class="text-xl font-bold tracking-tight text-gray-900">
          {{ (companyInfo?.company?.created_at | date:'dd/MM/yyyy') || '---' }}
        </p>
      </div>
    </div>
  </div>

  <!-- PRICING PLAN -->
  <div class="col-span-12 md:col-span-6 xl:col-span-3">
    <div class="min-h-[125px] rounded-2xl border border-gray-300 bg-white p-5">
      <div class="flex flex-col items-center justify-center text-center">
        <div class="mb-3 flex items-center justify-center gap-1">
          <p class="text-xs font-semibold uppercase tracking-[0.16em] text-gray-500">
            Pricing Plan
          </p>

          <mat-icon
            class="!text-[15px] !text-emerald-500"
            matTooltip="Description: {{ companyInfo?.company?.company_plan_description || 'Not available' }}"
          >
            info_outline
          </mat-icon>
        </div>

        <p class="max-w-full truncate text-xl font-bold tracking-tight text-gray-900">
          {{ companyInfo?.company?.company_plan_title || '---' }}
        </p>
      </div>
    </div>
  </div>

  <!-- TOTAL POSTS -->
  <div class="col-span-12 md:col-span-6 xl:col-span-3">
    <div class="min-h-[125px] rounded-2xl border border-gray-300 bg-white p-5">
      <div class="flex flex-col items-center justify-center text-center">
        <div class="mb-3 flex items-center justify-center gap-1">
          <p class="text-xs font-semibold uppercase tracking-[0.16em] text-gray-500">
            Total Posts
          </p>

          <mat-icon
            class="!text-[15px] !text-emerald-500"
            matTooltip="Total number of content views, including repeat views."
          >
            info_outline
          </mat-icon>
        </div>

        <div class="flex items-center justify-center gap-3">
          <p class="text-2xl font-bold tracking-tight text-gray-900">
            {{
              companyInfo?.total_posts?.filtered === null
                ? ((companyInfo?.total_posts?.all_time | number:'1.0-0':'el-GR') || 0)
                : ((companyInfo?.total_posts?.filtered | number:'1.0-0':'el-GR') || 0)
            }}
          </p>

          <button
            (click)="openPostsModal()"
            class="btn-calendar inline-flex cursor-pointer items-center justify-center rounded-xl bg-blue-600 p-2 text-white transition-colors hover:bg-blue-700"
          >
            <mat-icon class="mat-icon">calendar_today</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- DATE RANGE MODAL -->
<div
  *ngIf="showPostsModal"
  class="fixed inset-0 z-50 flex items-center justify-center p-4"
>
  <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

  <div class="relative z-10 max-h-[90vh] w-full max-w-2xl overflow-hidden rounded-2xl border border-gray-300 bg-white">
    <!-- MODAL HEADER -->
    <div class="border-b border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-4">
      <div class="grid grid-cols-12 items-center gap-4">
        <div class="col-span-10">
          <div class="border-l-4 border-gray-800 pl-4">
            <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
              Posts Section
            </p>
            <h2 class="mt-1 text-2xl font-bold tracking-tight text-gray-900">
              Date Range for Posts
            </h2>
          </div>
        </div>

        <div class="col-span-2 flex justify-end">
          <button
            (click)="closePostsModal()"
            class="inline-flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl text-gray-500 transition hover:bg-gray-100 hover:text-gray-900"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL CONTENT -->
    <div class="max-h-[calc(90vh-88px)] overflow-y-auto p-5 sm:p-6">
      <div class="grid grid-cols-1 gap-6">
        <!-- DATE RANGE SELECTION -->
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
          <!-- START DATE -->
          <div>
            <label class="mb-2 block text-sm font-semibold text-gray-700">
              Start Date
            </label>

            <input
              type="date"
              [(ngModel)]="startDate"
              (change)="onDateChange()"
              class="w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <!-- END DATE -->
          <div>
            <label class="mb-2 block text-sm font-semibold text-gray-700">
              End Date
            </label>

            <input
              type="date"
              [(ngModel)]="endDate"
              (change)="onDateChange()"
              [min]="startDate"
              class="w-full rounded-xl border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <!-- QUICK DATE PRESETS -->
        <div class="rounded-2xl border border-gray-300 bg-gray-50 p-4">
          <p class="mb-3 text-sm font-semibold text-gray-700">
            Quick Select:
          </p>

          <div class="flex flex-wrap gap-2">
            <button
              (click)="setDateRange(7)"
              class="cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
            >
              Last 7 Days
            </button>

            <button
              (click)="setDateRange(30)"
              class="cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
            >
              Last 30 Days
            </button>

            <button
              (click)="setDateRange(90)"
              class="cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
            >
              Last 90 Days
            </button>

            <button
              (click)="setThisMonth()"
              class="cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
            >
              This Month
            </button>

            <button
              (click)="setLastMonth()"
              class="cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
            >
              Last Month
            </button>
          </div>
        </div>

        <!-- SELECTED RANGE DISPLAY -->
        <div
          *ngIf="startDate && endDate"
          class="rounded-2xl border border-blue-200 bg-blue-50 p-4"
        >
          <p class="text-sm text-gray-700">
            Selected period:
            <span class="font-semibold text-gray-900">
              {{ startDate | date:'dd/MM/yyyy' }} - {{ endDate | date:'dd/MM/yyyy' }}
            </span>
          </p>

          <p class="mt-1 text-sm text-gray-600">
            Total days: {{ calculateDaysBetween() }}
          </p>
        </div>

        <!-- APPLY BUTTON -->
        <div>
          <button
            (click)="applyDateRange()"
            [disabled]="!startDate || !endDate"
            class="w-full cursor-pointer rounded-xl bg-blue-600 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Apply Date Range
          </button>
        </div>
      </div>

      <!-- MODAL FOOTER -->
      <div class="mt-6 flex flex-col-reverse gap-3 border-t border-gray-300 pt-6 sm:flex-row sm:items-center sm:justify-end">
        <button
          (click)="resetDates()"
          class="cursor-pointer rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50"
        >
          Reset
        </button>

        <button
          (click)="closePostsModal()"
          class="cursor-pointer rounded-xl border border-gray-300 bg-gray-100 px-5 py-2.5 text-sm font-semibold text-gray-800 transition-colors hover:bg-gray-200"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>